// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n-slider-track {
  background-color: var(--color-input-background);
  position: relative;
  flex-grow: 1;
  border-radius: 9999px;
  border: 1px solid var(--color-border-base);
  height: 6px;
}
.n-slider-track[data-disabled] {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/slider/SliderTrack.less"],"names":[],"mappings":"AAAA;EACE,+CAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,0CAAA;EACA,WAAA;AACF;AACE;EACE,YAAA;AACJ","sourcesContent":[".n-slider-track {\n  background-color: var(--color-input-background);\n  position: relative;\n  flex-grow: 1;\n  border-radius: 9999px;\n  border: 1px solid var(--color-border-base);\n  height: 6px;\n\n  &[data-disabled] {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
